console.log("init Proteus treatments -- 1.03")

// support for [IQB-14]
observeSelector('.slidecart-item-wrapper[data-item-selling-plan*="Delivery"], tr.line-item[data-item-selling-plan*="Delivery"]', sub_cart_item => {
  waitForElement('free-shipping-bar').then(fs_bar => {
    fs_bar.innerHTML = `
        <span class="shipping-bar_container"><span class="shipping-bar__text text--small" data-free="You are eligible for free shipping!" data-amount="Spend {{ remaining_amount }} more and get free shipping!">You are eligible for free shipping!</span>
        </span>
        <span class="shipping-bar__progress"></span>
    `;
    fs_bar.setAttribute("data-inline-text", "");
    fs_bar.setAttribute("style", "--progress: 1");
    fs_bar.setAttribute("threshold", "0.0");
  }).catch();
});

// START support for in-cart subscription management
document.addEventListener("change", async (e) => {
  if (!e.target.matches(".selling-plan-selector")) return;

  const lineKey = e.target.dataset.lineKey;
  const sellingPlanId = Number(e.target.value);

  await updateSellingPlan(lineKey, sellingPlanId);
});

document.addEventListener("click", async (e) => {
  if (!e.target.matches(".switch-to-2wk-plan")) return;

  const lineKey = e.target.dataset.lineKey;
  const sellingPlanId = Number(e.target.dataset.spId);

  await updateSellingPlan(lineKey, sellingPlanId);
});


async function updateSellingPlan(lineKey, sellingPlanId) {
  const res = await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: lineKey,
      selling_plan: sellingPlanId
    })
  });

  const cart = await res.json();

  // tell the theme to refresh the cart UI
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:refresh", {
      bubbles: true,
      detail: { cart }
    })
  );
}

// END support for in-cart subscription management

async function submitVariantViaProductForm(variantId, qty = 1) {
  const form = document.getElementById("hidden-product-form");
  if (!form) throw new Error("Hidden product form missing");

  // fill inputs
  form.querySelector('input[name="id"]').value = String(variantId);
  form.querySelector('input[name="quantity"]').value = String(qty);

  // wrap the event-driven flow in a Promise so we can await completion
  const done = new Promise((resolve) => {
    const onRefresh = (e) => {
      // product-form will dispatch cart:refresh with sections; resolve after it fires
      document.documentElement.removeEventListener("cart:refresh", onRefresh);
      resolve(e.detail);
    };
    document.documentElement.addEventListener("cart:refresh", onRefresh, { once: true });
  });

  // triggers ProductForm._onSubmit -> theme ajax add + events
  form.requestSubmit();

  return done; // resolves with the cart:refresh detail
}

// atc links -- #atc--12345678-3456789
observeSelector('[href*="#atc--"]', atc_link => {

  if(document.querySelectorAll(`#hidden-product-form`).length == 0){
    document.querySelector('body').insertAdjacentHTML("beforeend", `
    <form is="product-form"
      id="hidden-product-form"
      action="/cart/add"
      method="post"
      style="display:none">
      <input type="hidden" name="id" value="">
      <input type="hidden" name="quantity" value="1">
    </form>  
    `);
  }

  atc_link.addEventListener("click", async (e) => {

    let atc_href = e.currentTarget.getAttribute("href");
    const match = atc_href.match(/#atc--([\d\-]+)/);
    if (!match) return;

    const var_ids = match[1].split("-"); // ["12345678", "3456789"]

    // Build items array for cart/add.js
    const items = var_ids.map(id => ({
      id,
      quantity: 1
    }));

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });
      const data = await res.json();
      console.log("Added multiple items:", data);

      waitForElement('#mini-cart').then(cart => {
        if(cart.open){
          cart.open = false;
        }

        setTimeout(() => {
          document.querySelector('a[href="/cart"][is="toggle-link"]').click();
        }, (200));

        setTimeout(() => {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true
            })
          );
        }, (500));

      }).catch();

    } catch (err) {
      console.error("ATC error", err);
    }
  });
})

// joe: 40216908529798
// bar: 40216907939974

//
// START support for [IQB-02]
//
if(window.location.href.indexOf("qa=stayai") > -1 || window.sessionStorage.getItem("[IQB-02]")){

  console.log("init [IQB-02] v1")

  waitForElement('body').then(doc => {
    doc.insertAdjacentHTML("afterbegin", `
    <style>
    [data-slidecart-item="42412052349062"]{
      display: none !important;
    }
    </style>  
    `);
  })

  window.sessionStorage.setItem("[IQB-02]", true);
  console.log(`init Stay.ai treatment`);

  const var_id = 42412052349062;
  const selling_plan_id = '5478088838';
  const custom_props = {
    '_source': '[IQB-02]'
  };

  const random_number = Math.floor(Math.random() * 1001);

  const review_cart = () => {
    console.log("review_cart()");

    fetch('/cart.js').then(res => res.json()).then(cart => {

      window.cart_data = cart;

      const anySellingPlanExists = cart.items.some(item => !!item.selling_plan_allocation);
      const hasThatVariant = cart.items.some(item => (item.variant_id ?? item.id) === Number(var_id));
      
      const targetIds = [6738720358534, 4425539977350, 6648412045446, 6875386839174]; // 4 sample products
      const hasSpecificProduct = cart.items.some(item =>
        targetIds.includes(Number(item.product_id))
      );

      console.log("hasThatVariant", hasThatVariant, "hasSpecificProduct", hasSpecificProduct);


      // if (!hasThatVariant && cart.items.length > 0) {
      if (!hasThatVariant && hasSpecificProduct) {

        console.log("add item");

        // Otherwise, add to cart and then checkout
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: var_id,
            quantity: 1,
            properties: custom_props,
            selling_plan: selling_plan_id
          })
        }).then(res => res.json()).then(data => {

          console.log('Item added to cart:', data);
          // window.location.href = "/checkout";
        });
      }

    }).catch(err => {
      console.error('Cart fetch or ATC failed:', err);
    });

  }; // review_cart()

  /*
  var_ids: 
  40172370690182 -- iqjoe-original-variety-16-sticks
  39796293861510 -- ultimate-sampler
  39589852184710 -- 8-flavor-variety
  31461251874950 -- 7-bar-trial
  */

  function debounce(fn, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  }

  const debouncedReviewCart = debounce(review_cart, 500);

  observeSelector('[data-slidecart-item]', cart_item => {
    if(document.querySelectorAll('[data-slidecart-item="40172370690182"], [data-slidecart-item="39796293861510"], [data-slidecart-item="39589852184710"], [data-slidecart-item="31461251874950"]').length > 0){
      debouncedReviewCart();
    }
  });

} 
//
// END support for [IQB-02]
//